<template>
  <AccordionText
    :accordionText="active ? textOpen ?? text : text"
    :size="size"
    :active="active"
    @onClicked="onClicked"
  />
</template>
<script lang="ts" setup>
import AccordionText from './AccordionText.vue'

type Props = {
  text: string
  textOpen?: string
  size?: 'small' | 'medium' | 'large' | 'extrasmall'
  active?: boolean
}

type Emits = {
  (e: 'onClicked'): void
}

const emit = defineEmits<Emits>()

withDefaults(defineProps<Props>(), {
  size: 'medium',
  textOpen: undefined,
  active: false
})

function onClicked() {
  emit('onClicked')
}
</script>
